import { http } from 'services/http';
import { endpoint } from 'services/endpoint';
import { TOrdersSyncApi } from './types';

export const ordersSync: TOrdersSyncApi = {
	syncShopify: (payload) =>
		http.post(endpoint.ordersSync.SHOPIFY(Number(payload.id))).then((response) => response.data),
	syncWix: (payload) =>
		http.post(endpoint.ordersSync.WIX(Number(payload.id))).then((response) => response.data),
	syncShopware: (payload) =>
		http.post(endpoint.ordersSync.SHOPWARE(Number(payload.id))).then((response) => response.data),
};
